import { View, Text, StyleSheet, Platform, Pressable } from 'react-native';
import { Color, FontFamily, FontSize, Padding } from '@/GlobalStyles';
import { Image } from 'expo-image';
import { Href } from 'expo-router/build/link/href';
import { useTheme } from 'react-native-paper';
import { Link } from 'expo-router';
import SimpleLink from '@/components/SimpleLink';

export type EmptyStateProps = {
  emptyStateText?: string;
  emptyStateLinkText?: string;
  emptyStateLinkHref?: Href;
};

const EmptyState = (props: EmptyStateProps) => {
  const theme = useTheme();
  const {
    emptyStateText = 'Aucun élément pour le moment',
    emptyStateLinkText,
    emptyStateLinkHref,
  } = props;

  return (
    <View style={styles.container}>
      <Text style={[styles.title]}>{emptyStateText}</Text>
      {emptyStateLinkText && emptyStateLinkHref ? (
        <SimpleLink href={emptyStateLinkHref}>{emptyStateLinkText}</SimpleLink>
      ) : null}
    </View>
  );
};

export default EmptyState;

const styles = StyleSheet.create({
  icon: {
    height: 80,
    maxWidth: 530,
    width: '100%',
  },
  container: {
    maxWidth: 530,
    flex: 1,
    width: '100%',
    height: '100%',
    margin: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    flexDirection: 'column',
    paddingVertical: Padding.p_21xl,
  },
  title: {
    maxWidth: 300,
    fontSize: FontSize.h3_size,
    color: Color.MainNoir,
    textAlign: 'center',
    fontFamily: FontFamily.labelRegular,
    marginVertical: Padding.p_11xl,
  },
});
